import { render, staticRenderFns } from "./columnRole.vue?vue&type=template&id=49562730&scoped=true&"
import script from "./columnRole.vue?vue&type=script&lang=js&"
export * from "./columnRole.vue?vue&type=script&lang=js&"
import style0 from "./columnRole.vue?vue&type=style&index=0&id=49562730&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49562730",
  null
  
)

export default component.exports